var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgColumns = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3H19.5C20.3284 3 21 3.67157 21 4.5V7.5H9V3ZM8.25 1.5H19.5C21.1569 1.5 22.5 2.84315 22.5 4.5V8.25V19.5C22.5 21.1569 21.1569 22.5 19.5 22.5H8.25H4.5C2.84315 22.5 1.5 21.1569 1.5 19.5V4.5C1.5 2.84315 2.84315 1.5 4.5 1.5H8.25ZM9 21H19.5C20.3284 21 21 20.3284 21 19.5V9H9V21ZM7.5 21H4.5C3.67157 21 3 20.3284 3 19.5V9H7.5V21ZM3 7.5H7.5V3H4.5C3.67157 3 3 3.67157 3 4.5V7.5Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgColumns);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/columns.16f3d657ff37ed0809675772c1b61440.svg";